import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarStarFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M18.4601 16.8001C18.4601 17.1801 18.16 17.4801 17.7801 17.4801C17.4001 17.4801 17.1201 17.1801 17.1201 16.8001V16.0001H6.88006V16.8001C6.88006 17.1801 6.60003 17.4801 6.22003 17.4801C5.84009 17.4801 5.54004 17.1801 5.54004 16.8001V11.3001H18.4601V16.8001ZM16.92 14.0601H14.42C12.8744 15.4065 10.7368 15.1622 9.58007 14.0601H7.08007V12.5601H10.16C11.0421 13.7701 12.854 13.8796 13.8401 12.5601H16.92V14.0601Z"
      />
      <path
        fillRule="evenodd"
        d="M16.8722 10.0961L18.4425 9.05573L19.9601 10.0299V17.1001C19.7555 19.8243 16.376 19.5596 16.0201 17.5001H7.98004C7.70336 19.5189 4.20172 19.8039 4.04004 17.1001V11.2601L4.52008 10.2801H3.08008V8.68011H5.28009L6.96008 5.20013H13.324C13.3578 5.23217 14.8826 6.46984 14.8826 6.46984L14.8198 6.70013H7.90008L6.38006 9.80011H14.7443C15.0935 10.2965 16.091 10.6223 16.8722 10.0961ZM17.7801 17.4801C18.16 17.4801 18.4601 17.1801 18.4601 16.8001V11.3001H5.54004V16.8001C5.54004 17.1801 5.84009 17.4801 6.22003 17.4801C6.60003 17.4801 6.88006 17.1801 6.88006 16.8001V16.0001H17.1201V16.8001C17.1201 17.1801 17.4001 17.4801 17.7801 17.4801ZM19.4871 3.87372L22.4401 4.01941L20.1314 5.86029L20.9137 8.72894L18.4439 7.08752L15.9664 8.72894L16.7488 5.86029L14.4401 4.01941L17.3931 3.87372L18.4439 1.12012L19.4871 3.87372Z"
      />
    </SvgIcon>
  );
});
